// React
import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'
import { compose } from 'redux'

// Libraries
import _intersection from 'lodash/intersection'

// Components
import BServices from 'shop-components/components/MiniCart/styles/Services'
import Service from './Service'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronUp as farChevronUp, faChevronDown as farChevronDown } from '@fortawesome/pro-regular-svg-icons'

// Shared
import { withTranslation } from 'shared/utils/withTranslation'
import { Format as FormatUtils } from 'back_office/v2/utils/utils'
import ProductGroupActions from 'store/v2/redux/actions/product_group'

export const Services = ({ cart, lines, currency, services, servicesPrice, cartItemIds, t }) => {
  const prevCartRef = useRef(cart)
  const headerElementRef = useRef(null)

  const [open, setOpen] = useState(true)

  useEffect(() => {
    ProductGroupActions.fetchServices({ cart_id: cart.id })
  }, [cart.id])

  useEffect(() => {
    const previousCart = prevCartRef.current
    const newCart = !previousCart && cart
    const fromChanged = cart && !newCart ? previousCart.starts_at !== cart.starts_at : false
    const tillChanged = cart && !newCart ? previousCart.stops_at !== cart.stops_at : false

    if (cart && (newCart || fromChanged || tillChanged)) {
      ProductGroupActions.fetchServices({ cart_id: cart ? cart.id : undefined })
    }

    prevCartRef.current = cart
  }, [cart])

  const isServiceInCart = (serviceId) => {
    return cartItemIds.includes(serviceId)
  }

  const handleToggleOpen = () => {
    setOpen((prev) => !prev)
  }

  if (!services?.size()) {
    return null
  }

  return (
    <BServices open={open} headerHeight={headerElementRef.current?.getBoundingClientRect().height}>
      <BServices.Header ref={headerElementRef} open={open} onClick={handleToggleOpen}>
        <BServices.Title>{t('user.store.additional_services')}</BServices.Title>
        <BServices.Total>{FormatUtils.money(servicesPrice, currency)}</BServices.Total>
        <FontAwesomeIcon icon={open ? farChevronUp : farChevronDown} />
      </BServices.Header>
      {services.map((service) => {
        const inCart = isServiceInCart(service.id)

        return <Service key={service.id} lines={lines} service={service} inCart={inCart} />
      })}
    </BServices>
  )
}

Services.displayName = 'ServiceLines'
Services.propTypes = {
  cart: PropTypes.object,
  currency: PropTypes.object,
  lines: PropTypes.object,
  services: PropTypes.object,
  servicesPrice: PropTypes.number,
  cartItemIds: PropTypes.object,
  t: PropTypes.func
}

const mapStateToProps = (state, props) => {
  const currency = state.client.currency.toJS()
  const lines = state.orm.lines.getAll({ id: props.cart?.lines })
  const cartItemIds = lines.map((line) => line.item_id)
  const services = state.orm.product_groups.getAll({ product_type: 'service', show_in_store: true })
  const enabledServices = state.orm.products
    .getAll({ product_type: 'service', product_group_id: services.pluck('id') })
    .sortBy((service) => services.getById(service.product_group_id).sorting_weight)

  const selectedServices = lines.getAll({ item_id: _intersection(cartItemIds.toArray(), enabledServices.pluck('id')) })
  const servicesPrice = selectedServices.toArray().reduce((sum, { display_price_in_cents: price }) => sum + price, 0)

  return {
    currency,
    lines,
    services: enabledServices,
    servicesPrice,
    cartItemIds
  }
}

export default compose(withTranslation('user'), reduxConnect(mapStateToProps))(Services)
